module.exports = __webpack_public_path__ + "static/Charlotte-0d91b1a2facac1783370c660683096a5.jpg";